import { render, staticRenderFns } from "./PeakSize.vue?vue&type=template&id=76fa83fb"
import script from "./PeakSize.vue?vue&type=script&lang=js"
export * from "./PeakSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports